/////////////////////////////////////////////////////////////////////////////////////////////////////////
//FileName: *management-units*.main.js
//FileType: Javascript Source file
//Size : ?
//Author : Harun Durmuş
//Created On : 11.12.2020 14:51
//Last Modified On : ?
//Copy Rights : Oceannet
//Description : Catalog>Management Units Component
////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import $ from "jquery";
import Detail from "./Detail";
import Edit from "./Edit";
import Table from "./Table";
import CreateArea from "./modals/createArea";
import RowDeleteModal from "../../modal/rowDelete";
import KoppelenGebruiker from "./modals/koppelenGebruiker";
import KoppelenDiscipline from "./modals/koppelenDiscipline";
import * as CommonFunctions from "./functions/commonFunctions";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";

class ManagementUnits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    var that = this;
    ColumnList.forEach(function (item) {
      if (item.name == "catalog>area") {
        window.$catalog_area_columnList = item["column-list"];
      }
    });

    /*** EKRANIN HERHANGİ BİRYERİNE TIKLANINCA POPUP KALDIRMAK İÇİN KULLANILAN FONKSİYON ***/
    $(document)
      .unbind("mouseup")
      .mouseup(function (e) {
        var popup = $("#myPopup");
        if (
          !$("div.popup").is(e.target) &&
          !popup.is(e.target) &&
          popup.has(e.target).length === 0
        ) {
          $("#myPopup").html("");
          var popup = document.getElementById("myPopup");
          $("#myPopup").removeClass("show");
        }
      });

    $(document).on("click", ".area-catalog-action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$catalog_area_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });
  }

  render() {
    return (
      <div className="border p-3 br5 full-width" id="border-mid">
        <Table {...this.props} />
        <Detail />
        <Edit />
        <CreateArea />
        <KoppelenGebruiker />
        <KoppelenDiscipline />
        <RowDeleteModal
          id="area-mappen_beheren_delete_modal"
          handleDelete={CommonFunctions.rowsHandleDelete}
        />
      </div>
    );
  }
}

export default ManagementUnits;
